import React, {useState, useEffect} from 'react';
import Breadcrumb from '../../common/breadcrumb';
import apiClient from "../../../utils/apiClient";
import {toast} from "react-toastify";
import {isEmpty} from "lodash"
import TableReport from "../../common/table/table";
import BillingPeriodsTable from "./BillingPeriodsTable";
import ModalConfirmation from "../../common/modal/ModalConfirmation";
import {removeObjFromArray} from "../../../utils/arrayHelpers";
import BillingPeriodsFormModal from "./BillingPeriodsFormModal";

const BillingPeriods = () => {
    const [tableData, setTableData] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [formModal, setFormModal] = useState({isOpen: false, action: 'create'});
    const [deleteModal, setDeleteModal] = useState({isOpen: false, message: <p></p>});

    // delete function
    const deleteBillingPeriod = () => {
        apiClient
            .delete('billingPeriods/' + selectedRow.id)
            .then(response => {
                const newTableData = removeObjFromArray(tableData, "id", response.data.id)
                setTableData(newTableData);
                toast.success(response.data.message);
            })
            .catch(function () {
                //In case of error do nothing!!
                //let apiClient to handle the error
            })
            .then(function () {
                //close deactivateModal
                setDeleteModal({...deleteModal, isOpen: false})
            });
    }

    useEffect(() => {
        apiClient
            .get('billingPeriods')
            .then(response => {
                if (isEmpty(response.data)) {
                    setTableData([]);
                    return;
                }
                setTableData(response.data.periods);
            });
    }, [setTableData]);

    return (
        <>
            <Breadcrumb title="Payment Terms" parent="Admin"/>
            <div className="container-fluid">
                <TableReport
                    columns={BillingPeriodsTable(setSelectedRow, setFormModal, setDeleteModal)}
                    data={tableData}
                    getExportFileName={() => 'payment_terms'}
                />
                <BillingPeriodsFormModal
                    title="Payment Term"
                    modal={formModal}
                    setModal={setFormModal}
                    tableData={tableData}
                    setTableData={setTableData}
                    selectedRow={selectedRow}
                />
                <ModalConfirmation
                    modal={deleteModal}
                    setModal={setDeleteModal}
                    title="Delete Payment Term"
                    onConfirm={deleteBillingPeriod}
                />
            </div>
        </>
    );
}

export default BillingPeriods;
